import * as api from "../api/api";

export const mpStateOptions = [{
    label: "全部",
    value: "",
  },
  {
    label: "已授权",
    value: 1,
  },
  {
    label: "未授权",
    value: 0,
  },
];
export const defaultAll = [{
  label: "全部",
  labelEn: "All of it",
  value: -1,
}, ];

export const orderMenuListSlice = [{
    label: "待付款",
    labelEn: "Pending Payment",
    value: 0,
  },
  // {
  //   label: "待成团",
  //   labelEn: "Waiting for Group Buy",
  //   value: 1,
  // },
  // {
  //   label: "待发货",
  //   labelEn: "Pending Shipment",
  //   value: 2,
  // },
  {
    label: "待收/提货",
    labelEn: "Delivering/Ready for Pickup",
    value: 3,
  },
];

export const orderHotelMenuListSlice = [
    {
    label: "待付款",
    labelEn: "Pending Payment",
    value: 0,
  },
  {
    label: "待受理",
    labelEn: "Pending Transaction",
    value: 1,
  },
  {
    label: "已完成",
    labelEn: "Complete",
    value: 3,
  },
  {
    label: "已退款",
    labelEn: "Refunded",
    value: 4,
  },
  {
    label: "已取消",
    labelEn: "Cancelled",
    value: 5,
  },
];

export const orderStateOptions = {
  0: {
    label: "待付款",
    labelEn: "Pending Payment",
    btns: [{
        chName: "取消订单",
        enName: "Cancel the order",
        btnType: "normal",
        funName: "cancelOrder",
      },
      {
        chName: "去付款",
        enName: "Payment",
        btnType: "primary",
        funName: "payGoods",
      },
    ],
  },
  1: {
    label: "待成团",
    labelEn: "Waiting for Group Buy",
    btns: [{
      chName: "立即分享",
      enName: "Share now",
      btnType: "primary",
      funName: "toMiniAppOrderInfo",
    }, ],
  },
  2: {
    label: "待发货",
    labelEn: "Pending Shipment",
    btns: [{
      chName: "取消订单",
      enName: "Cancel the order",
      btnType: "normal",
      funName: "cancelOrder",
    }, ],
  },
  3: {
    label: "待收/提货",
    labelEn: "Delivering/Ready for Pickup",
    btns: [{
        chName: "物流单号",
        enName: "Shipping",
        btnType: "normal",
        funName: "checkLogistics",
      },
      {
        chName: "确认收货",
        enName: "Receiving goods",
        btnType: "primary",
        funName: "confrimGet",
      },
    ],
    btns1: [{
      chName: "提货码",
      enName: "Pick-up code",
      btnType: "primary",
      funName: "viewDetails",
    }, ],
  },
  4: {
    label: "已完成",
    labelEn: "Complete",
    btns: [{
        chName: "申请开票",
        enName: "Apply invoice",
        btnType: "primary",
        funName: "toMiniAppOrderInfo",
        hidden: true,
      },
      {
        chName: "开票信息",
        enName: "Info invoice",
        btnType: "normal",
        funName: "toMiniAppOrderInfo",
        hidden: true,
      },
    ],
  },
  5: {
    label: "已关闭",
    labelEn: "Has Been Closed",
    btns: [],
  },
  8: {
    label: "待收货",
    labelEn: "Delivering for pickup",
    btns: [{
        chName: "提货地址",
        enName: "Pick-up address",
        btnType: "logisticAddress",
        funName: "checkAddress",
      },
      {
        chName: "提货码",
        enName: "RPick-up code",
        btnType: "primary",
        funName: "checkCode",
      },
    ],
  },
};

export const orderHotelStateOptions = {
  0: {
    label: "待付款",
    labelEn: "Pending Payment",
    btns: [{
        chName: "取消订单",
        enName: "Cancel the order",
        btnType: "normal",
        funName: "cancelOrder",
      },
      {
        chName: "去付款",
        enName: "Payment",
        btnType: "primary",
        funName: "payGoods",
      },
    ],
  },
  1: {
    label: "待受理",
    labelEn: "Pending Transaction",
    btns: [{
      chName: "取消订单",
      enName: "Cancel the order",
      btnType: "normal",
      funName: "cancelOrder",
    }, ],
  },
  3: {
    label: "已完成",
    labelEn: "Complete",
  },
  4: {
    label: "已退款",
    labelEn: "Refunded",
  },
  5: {
    label: "已取消",
    labelEn: "Cancelled",
  },
};
//订单状态 0待付款 1待成团 2待发货 3待收货 4已完成 5已关闭
export const orderStatusOptions =  {
  0:{
    label: "待付款",
    labelEn: "Pending Payment",
  },
  1:{
    label: "待成团",
    labelEn: "Waiting for Group Buy",
  },
  2:{
    label: "待发货",
    labelEn: "Pending Shipment",
  },
  3:{
    label: "待收货",
    labelEn: "Delivering for pickup",
  },
  4:{
    label: "已完成",
    labelEn: "Complete",
  },
  5:{
    label: "已关闭",
    labelEn: "Has Been Closed",
  },
}
export const paymentMethodOptions=[
      {//支付方式 options
        value: 'wechat',
        label: '微信/会员钱包支付 Wechat / member wallet payment'
      },
      {
        value: 'foreign',
        label: '外卡支付 Foreign currency payment'
      }
    ];
//支付渠道 0微信 1储值卡 2支付宝 3外卡支付
export const payChannelOptions={
  0:{
    label: "微信支付",
    labelEn: "Wechat payment",
  },
  1:{
    label: "钱包支付",
    labelEn: "Stored value card payment",
  },
  2:{
    label: "支付宝支付",
    labelEn: "Alipay payment",
  },
  3:{
    label: "外卡支付",
    labelEn: "Foreign currency payment",
  },
}
export const couponType = {
  0: {
    label: "现金券",
    labelEn: "Cash coupons"
  },
  1: {
    label: "折扣券",
    labelEn: "Discount Coupons"
  },
  2: {
    label: "礼品券",
    labelEn: "Gift vouchers"
  },
  3: {
    label: "充值券",
    labelEn: "Recharge coupon"
  },
}
//用户奖励金流水_有效渠道列表
export const getGroupListOptions = () => {
  const params = {
    sceneMarketSwitch: 1,
    status: 1,
  };
  return api.getGroupList(params).then((res) => {
    return (res.data || []).map((item) => {
      return {
        label: item.entityName,
        value: item.id,
        labelEn: item.entityEnName,
      };
    });
  });
};